import React from 'react';
import { JsonLd } from 'react-schemaorg';

import { GOOGLE_RATING, GOOGLE_REVIEW_COUNT } from '@constants/googleRating';

const SeoProduct = () => (
  <JsonLd
    item={{
      '@context': 'https://schema.org/',
      '@type': 'Product',
      name: 'Achievable exam prep',
      description:
        'Achievable is the most effective way to ace your professional exams and boost your career. Study on the go from your phone or computer. Industry best pass rates.',
      aggregateRating: {
        '@type': 'AggregateRating',
        ratingValue: GOOGLE_RATING,
        ratingCount: GOOGLE_REVIEW_COUNT,
      },
      brand: {
        '@type': 'Organization',
        name: 'Achievable',
      },
      offers: {
        '@type': 'AggregateOffer',
        highPrice: '389',
        lowPrice: '79',
        offerCount: '11',
        priceCurrency: 'USD',
        availability: 'https://schema.org/InStock',
        offers: [
          {
            '@type': 'Offer',
            url: 'https://achievable.me/exams/finra-sie/overview/',
          },
          {
            '@type': 'Offer',
            url: 'https://achievable.me/exams/finra-series-6/overview/',
          },
          {
            '@type': 'Offer',
            url: 'https://achievable.me/exams/finra-series-7/overview/',
          },
          {
            '@type': 'Offer',
            url: 'https://achievable.me/exams/finra-series-9/overview/',
          },
          {
            '@type': 'Offer',
            url: 'https://achievable.me/exams/finra-series-63/overview/',
          },
          {
            '@type': 'Offer',
            url: 'https://achievable.me/exams/finra-series-65/overview/',
          },
          {
            '@type': 'Offer',
            url: 'https://achievable.me/exams/finra-series-66/overview/',
          },
          {
            '@type': 'Offer',
            url: 'https://achievable.me/exams/act/overview/',
          },
          {
            '@type': 'Offer',
            url: 'https://achievable.me/exams/gre/overview/',
          },
          {
            '@type': 'Offer',
            url: 'https://achievable.me/exams/usmle-step-1/overview/',
          },
          {
            '@type': 'Offer',
            url: 'https://achievable.me/exams/amc-8-10-12/overview/',
          },
        ],
        seller: {
          '@type': 'Organization',
          name: 'Achievable',
        },
      },
    }}
  />
);

export default SeoProduct;
